// extracted by mini-css-extract-plugin
export default {"primary":"button_primary__Hm0qs","default":"button_default__tMyrw","active":"button_active__Pw95D","navmobile":"button_navmobile__rxBr1","icon":"button_icon__bBjQI"};